/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  FineTuningEvent,
  FineTuningEvent$inboundSchema,
  FineTuningEvent$Outbound,
  FineTuningEvent$outboundSchema,
} from "./finetuningevent.js";

export type ListEventsResponse = {
  object: "list";
  data: Array<FineTuningEvent>;
  hasMore: boolean;
};

/** @internal */
export const ListEventsResponse$inboundSchema: z.ZodType<
  ListEventsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(FineTuningEvent$inboundSchema),
  has_more: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    "has_more": "hasMore",
  });
});
/** @internal */
export type ListEventsResponse$Outbound = {
  object: "list";
  data: Array<FineTuningEvent$Outbound>;
  has_more: boolean;
};

/** @internal */
export const ListEventsResponse$outboundSchema: z.ZodType<
  ListEventsResponse$Outbound,
  z.ZodTypeDef,
  ListEventsResponse
> = z.object({
  object: z.literal("list"),
  data: z.array(FineTuningEvent$outboundSchema),
  hasMore: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    hasMore: "has_more",
  });
});

export function listEventsResponseToJSON(
  listEventsResponse: ListEventsResponse,
): string {
  return JSON.stringify(
    ListEventsResponse$outboundSchema.parse(listEventsResponse),
  );
}
export function listEventsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListEventsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEventsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEventsResponse' from JSON`,
  );
}
